import { render } from "./NPCs.vue?vue&type=template&id=bf2b59e4&scoped=true"
import script from "./NPCs.vue?vue&type=script&lang=js"
export * from "./NPCs.vue?vue&type=script&lang=js"

import "./NPCs.vue?vue&type=style&index=0&id=bf2b59e4&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf2b59e4"]])

export default __exports__